module.exports = __webpack_public_path__ + "static/media/mix-icon-1.bca449f4.png";